import ko from 'knockout';
import kx from '@/gr/common/knockout/extended';
import { defineComponent } from '@/gr/common/knockout/defineComponent';
import { SocialManagerArgs } from '@/gr/common/social/socialManager/socialManager';
import { ImageRenderer } from '@/gr/common/social/imageRenderer';
import '@/gr/common/knockout/bindings/fadeVisible';

export interface IImageDefinition {
  linkUrl: string;
  imageUrl: string;
  tooltip: string;
}

export class EmbeddableContainerArgs {
  constructor(
    public embedUrl: kx.ReadOnlyObservable<string>,
    public widgetLogo: IImageDefinition,
    public sponsorLogo: IImageDefinition | undefined,
    public sizingEmbeddableContainerToContent: kx.ReadOnlyObservable<boolean>,
    public subHeaderTemplateId?: string
  ) {}
}

enum DropDownState {
  Closed = 0,
  Export = 1
  // Share = 2
}

class EmbeddableContainerViewModel {
  dropDownState = ko.observable<DropDownState>(DropDownState.Closed);
  isDropdownMenuVisible = ko.pureComputed(() => this.dropDownState() > 0);
  socialManager: SocialManagerArgs;
  screenshotAnnotation: { url: string };
  embedUrl: kx.ReadOnlyObservable<string>;

  constructor(
    public params: EmbeddableContainerArgs,
    public element: Node
  ) {
    this.embedUrl = this.params.embedUrl;
    this.screenshotAnnotation = { url: window.location.href };
    this.socialManager = new SocialManagerArgs(new ImageRenderer());
  }
}

import html from './embeddableContainer.html';
defineComponent(() => EmbeddableContainerViewModel, 'embeddableContainer', html);
require('./embeddableContainer.less');
